import { getBrowsingApiV1 } from './browsing/get-browsing-api';
import { getGiftCardsApiV1 } from './gift-cards/get-gift-cards-api';
import { getJourneysApiV1 } from './journeys/get-journeys-api';
import { getLoyaltyApiV1 } from './loyalty/get-loyalty-api';
import { getOrdersApiV1 } from './orders/get-orders-api';
import { getPaymentsApiV1 } from './payments/get-payments-api';
import { getSalesApiV1 } from './sales/get-sales-api';
import { getSeatingApiV1 } from './seating/get-seating-api';
import { getWorkstationsApiV1 } from './workstations/get-workstations-api';
export function getOcapiV1(props) {
    const { httpClient, journeysHttpClient } = props;
    return {
        browsing: getBrowsingApiV1(httpClient),
        giftCards: getGiftCardsApiV1(httpClient),
        journeys: getJourneysApiV1(journeysHttpClient !== null && journeysHttpClient !== void 0 ? journeysHttpClient : httpClient),
        loyalty: getLoyaltyApiV1(httpClient),
        orders: getOrdersApiV1(httpClient),
        payments: getPaymentsApiV1(httpClient),
        sales: getSalesApiV1(httpClient),
        seating: getSeatingApiV1(httpClient),
        workstations: getWorkstationsApiV1(httpClient)
    };
}
//# sourceMappingURL=get-ocapi-v1.js.map